import React from 'react'

// bootstrap
import {
    OverlayTrigger,
} from 'react-bootstrap'

// icons : feather
import FeatherIcon from 'feather-icons-react';

// tooltips
import { renderTooltipClose } from 'utlis/helpers/Tooltips/CommonTooltips'

export default function EditVariantMoreDetailsModal(props) {
    // states
    const {
        closeModal,
        modalData,
        variantSelectedId,

        handleVariantLengthChange,
        handleVariantWidthChange,
        handleVariantHeightChange,
        handleVariantUPCChange,
        handleVariantDescriptionChange,
    } = props

    return (
        <div className="app-modal-content modal_edit-variant-more-details">
            <div className="close-icon">
                <OverlayTrigger
                    placement={"bottom"}
                    overlay={renderTooltipClose}
                >
                    <button
                        className="st-round-btn st-btn-transparent st-btn-sm d-flex align-items-center justify-content-center"
                        onClick={closeModal}
                    >
                        <FeatherIcon
                            icon="x"
                            size="17"
                            className="icon st-text-primary" />
                    </button>
                </OverlayTrigger>
            </div>

            {/* content */}
            <div className="edit-variant-more-details-container">
                {/* heading */}
                <div className="app-modal-title-wrapper">
                    <p className="app-modal-title text-capitalize">Edit Details</p>
                </div>

                {/* form */}
                <div className="form">

                    {/* form field */}
                    <div className="st-form st-form-with-label-left d-flex flex-wrap align-items-center">
                        <label style={{ width: 100 }}>Length</label>
                        <div className="media-body st-form-input-container pe-0">
                            <input type="text" className="form-control" placeholder="Length"
                                defaultValue={modalData[0].length} onChange={ev => handleVariantLengthChange(ev, variantSelectedId)} />
                        </div>
                    </div>

                    {/* form field */}
                    <div className="st-form st-form-with-label-left d-flex flex-wrap align-items-center">
                        <label style={{ width: 100 }}>Width</label>
                        <div className="media-body st-form-input-container pe-0">
                            <input type="text" className="form-control" placeholder="Width"
                                defaultValue={modalData[0].width} onChange={ev => handleVariantWidthChange(ev, variantSelectedId)} />
                        </div>
                    </div>

                    {/* form field */}
                    <div className="st-form st-form-with-label-left d-flex flex-wrap align-items-center">
                        <label style={{ width: 100 }}>Height</label>
                        <div className="media-body st-form-input-container pe-0">
                            <input type="text" className="form-control" placeholder="Height"
                                defaultValue={modalData[0].height} onChange={ev => handleVariantHeightChange(ev, variantSelectedId)} />
                        </div>
                    </div>

                    {/* form field */}
                    <div className="st-form st-form-with-label-left d-flex flex-wrap align-items-center">
                        <label style={{ width: 100 }}>UPC</label>
                        <div className="media-body st-form-input-container pe-0">
                            <input type="text" className="form-control" placeholder="UPC"
                                defaultValue={modalData[0].upc} onChange={ev => handleVariantUPCChange(ev, variantSelectedId)} />
                        </div>
                    </div>

                    {/* form field */}
                    <div className="st-form st-form-with-label-left d-flex flex-wrap">
                        <label style={{ width: 100 }}>Description</label>
                        <div className="media-body st-form-input-container pe-0">
                            <textarea rows="5" className="form-control" placeholder="Description"
                                defaultValue={modalData[0].description} onChange={ev => handleVariantDescriptionChange(ev, variantSelectedId)}></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <div className="btns d-flex justify-content-end pt-3">
                <button className="st-btn st-btn-primary no-min-width" onClick={closeModal}>
                    Close
                </button>
            </div>
        </div>
    )
}
